import { Component, OnInit } from '@angular/core';
import {Localization} from '../../common/enums/localization';

@Component({
  selector: 'app-account-error',
  templateUrl: './account-error.component.html',
  styleUrls: ['./account-error.component.scss']
})
export class AccountErrorComponent implements OnInit {

  public readonly Localization = Localization;

  constructor() { }

  ngOnInit() {
  }

}
